import type { CSSProperties, ReactNode } from "react";
import { useEmbedTokens } from "../theme";

type Tone = "error" | "success";

interface Props {
  tone: Tone;
  children: ReactNode;
}

// A full-width status/alert banner. Error uses role=alert (assertive);
// success uses role=status (polite).
export function EmbedBanner({ tone, children }: Props) {
  const t = useEmbedTokens();
  const palette =
    tone === "error"
      ? { bg: t.colors.errorBg, border: t.colors.error, text: t.colors.error }
      : { bg: t.colors.successBg, border: t.colors.successGreen, text: t.colors.successGreen };
  const style: CSSProperties = {
    display: "flex", alignItems: "center", gap: t.spacing.sm,
    background: palette.bg, border: `1px solid ${palette.border}`, color: palette.text,
    borderRadius: t.borderRadius, padding: `${t.spacing.sm}px ${t.spacing.md}px`,
    fontSize: t.fontSize.sm, lineHeight: t.lineHeight.normal, boxSizing: "border-box",
  };
  return (
    <div role={tone === "error" ? "alert" : "status"} style={style}>
      {children}
    </div>
  );
}
